import type { FaireProductEntity } from "../../entity_types/product";

export const p_5jkm86w: FaireProductEntity = {
  token: "p_5jkm86w",
  type: "product",
  name: "Creamy Pistachio Spread",
  brandName: "Oskr\u00f6",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/92f1720de98adede92a4e1ce7abff38652be4359bc4363a724996e08cb676bc0.webp",
  priceDollars: 14.5,
  description: "Premium pistachio spread perfect for breakfast or snacking",
  categoryTokens: ["cat_food-snacks"],
  tags: ["nyc-local", "premium", "artisanal", "spreads"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/92f1720de98adede92a4e1ce7abff38652be4359bc4363a724996e08cb676bc0.webp",
  weight: 0.6,
  dimensions: {
    width: 3,
    height: 4,
    depth: 3,
  },
  inStock: true,
};
